export const HMAC_SIGNATURE_LENGTH = 32
export const IV_LENGTH = 16
export const KEY_LENGTH = 32
export const DEFAULT_RSA_KEYSIZE = 4096
